import React from 'react';

import { Button, Icon } from '@digital/ui';
import { Tooltip } from 'antd';

import { Visibility } from '../Visibility';
import { isObjNotEmpty } from '@app/helpers/objHelper';

interface IFormValues {
  arquivo?: any;
}

interface IUploadProps {
  idDoComponente: string;
  visible?: boolean;

  buttonToolTip?: string;
  buttonIcon?: React.ComponentProps<typeof Icon>['name'];
  buttonText?: string;
  buttonClass?: string;

  hasFile?: boolean;

  disabled?: boolean;
  type?: "default" | "primary" | "ghost" | "dashed" | "danger" | "link";

  onUploadVisible?: boolean;
  onUpload: (values: IFormValues) => void;

  onDownloadVisible?: boolean;
  onDownload?: () => void;
}

export const UploadSimpleComponent = (
  {
    idDoComponente,
    visible = true,
    buttonIcon = 'ui-upload',
    buttonText,
    buttonToolTip = 'Adicionar Arquivo',
    buttonClass = '',
    hasFile = false,
    disabled,
    type = 'link',
    onUploadVisible = true,
    onUpload,
    onDownloadVisible = true,
    onDownload,
  }: IUploadProps) => {


  const triggerMudanca = (target: any) => {
    var parent = target.parentElement
    if (parent) {
      var input = target.parentElement.firstChild
      if (input) {
        input.click()
      }
    }
  };

  return (
    <Visibility
      visible={visible}
    >
      <Visibility
        visible={onUploadVisible}
      >
        <input
          id={`mrn-input-upload-${idDoComponente}`}
          type="file"
          onChange={(e) => {
            if (e.target) {
              const curFiles = e.target.files;

              if (curFiles && isObjNotEmpty(curFiles)) {
                onUpload({ arquivo: curFiles[0] } as IFormValues);
              }
            }
          }}
          className="custom-input-type-file"
          style={{ cursor: 'pointer !important', display: 'none' }}
        />

        <Tooltip title={buttonToolTip} >
          <Button
            id={`mrn-button-upload-${idDoComponente}`}
            icon={buttonIcon}
            onClick={(e) => triggerMudanca(e.currentTarget)}
            className={`${(hasFile ? 'has-comments ' : '')} ${buttonClass}`}
            title={buttonText}
            disabled={disabled}
            type={type ? type : 'link'}
          />
        </Tooltip>
      </Visibility>

      <Visibility visible={onDownloadVisible}>
        <Tooltip title="Download Arquivo">
          <Button
            id='mrn-button-download-SimpleUpload'
            type={type ? type : 'link'}
            icon="ui-download"
            onClick={onDownload}
          >
          </Button>
        </Tooltip>
      </Visibility>
    </Visibility>
  );
};
